import { ISubtitle } from '@vbrick/vbrick-player';

import { formatTimespan, formatTimeToSeconds } from 'rev-shared/date/DateFormatters';

export function formatSrt(entries: ISubtitle[]): string {
	return entries
		.map((entry, i) => formatSrtEntry(i + 1, entry))
		.join('\n\n') + '\n';
}

function formatSrtEntry(counter: number, entry: ISubtitle): string {
	return [
		'' + counter,
		`${formatTime(entry.start)} --> ${formatTime(entry.end)}`,
		entry.text.trim()
	].join('\n');
}

function formatTime(time: number): string {
	return formatTimespan(time * 1000, {
		decimalSeparator: ',',
		includeMilliseconds: true,
		noDays: true,
		padFields: true
	});
}

/**
 * @param timestamp expected format is in HH:mm:ss,SSS (SRT timestamp format) e.g. 00:00:01,000
 * @returns timestamp in seconds
 */
export function srtTimeToSeconds(timestamp: string): number {
	// Replace ',' with '.' to make it compatible
	const normalizedTimestamp = timestamp.replace(',', '.');
	return formatTimeToSeconds(normalizedTimestamp);
}
